module.exports = __webpack_public_path__ + "static/media/boxycat_banner.98d86d83.png";